module.exports = __webpack_public_path__ + "img/a7cea64.png";